import { render, staticRenderFns } from "./project-result-detail.html?vue&type=template&id=7ea8c22e&"
import script from "./project-result-detail.ts?vue&type=script&lang=ts&"
export * from "./project-result-detail.ts?vue&type=script&lang=ts&"
import style0 from "./project-result-detail.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports